<div *ngIf="isLoading | async">
  <div class="loader"></div>
</div>
